import { useRecurly } from "@recurly/react-recurly"
import React, { useState } from "react"
import CustomLoader from "../CustomLoader";
import toast from "react-hot-toast";


const CustomGooglePayButton = ({ type = "purchase", plan, googlePayCallButtonback }) => {

    const recurly = useRecurly()
    const [loading, setLoading] = useState(false);
    const [googlePayIsReady, setGooglePayIsReady] = useState(false)

    const total = plan && type === "purchase"
        ? plan.trial_length > 1
            ? "0.00"
            : (plan.amount ? (plan.amount + "") : "0.00")
        : "0.00";

    // trial_length
    const googlePay = recurly.GooglePay({
        googleMerchantId: process.env.REACT_APP_GPAY_MERCHANT_ID,
        environment: 'PRODUCTION',
        requireBillingAddress: true,
        gatewayCode: process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_RECURLY_PAYMENT_GATEWAY : process.env.REACT_APP_RECURLY_PAYMENT_GATEWAY_DEV,
        country: "US",
        currency: "USD",
        total: total,
        buttonOptions: {
            buttonType: 'subscribe'
        }
    });


    googlePay.on("ready", (googlePayButton) => {
        setGooglePayIsReady(true)
        if (!googlePayIsReady) {
            const el = document.getElementById("google-pay-button-container")
            if (el?.childElementCount < 1) {
                el?.appendChild(googlePayButton)
                const gpayBtn = document.getElementsByClassName("gpay-button")
                gpayBtn.item(0)?.classList.add("choose-plan-btn")
            }
        }
    })

    googlePay.on("token", async (token) => {
        try {
            if (!token) {
                toast.error("Unable to setup Google Pay");
            } else {
                googlePayCallButtonback(token);
            }

        } catch (err) {
            toast.error("Unable to setup Google Pay");
        }
    })

    googlePay.on("error", (err) => {
        if (err.name.includes("error") || err.code.includes("error") || err.message.includes("error")) {
            toast.error("Unable to setup Google Pay");
        }
    })


    return (
        <>
            <div id="google-pay-button-container" />
            {loading && <CustomLoader loading={loading} />}
        </>
    )
}

export default CustomGooglePayButton
